import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-call-for-rate',
  standalone: true,
  imports: [MatTooltipModule, MatIconModule],
  template: `
    <div class="phone-display">
      @if (isMobile) {
      <a [href]="'tel:' + phoneNumber" class="flex items-center gap-1">
        <mat-icon class="!w-4 !h-4 !text-base !leading-4">phone</mat-icon>
        <span>Call for rate</span>
      </a>
      } @else {
      <div class="phone-tooltip" matTooltip="{{ phoneNumber }}" matTooltipPosition="above">Call for rate</div>
      }
    </div>
  `,
  styles: [],
})
export class CallForRateComponent implements OnInit {
  @Input() phoneNumber: string = '';
  isMobile: boolean = false;
  readonly destroy$ = new Subject<void>();

  constructor(private platform: Platform, private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    this.detectMobile();
    this.observeWindowResize();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private detectMobile() {
    const isMobilePlatform = this.platform.ANDROID || this.platform.IOS;

    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      const isSmallScreen = result.matches;
      this.isMobile = isMobilePlatform || isSmallScreen;
    });
  }
  private observeWindowResize() {
    fromEvent(window, 'resize')
      .pipe(debounceTime(200), takeUntil(this.destroy$))
      .subscribe(() => {
        this.detectMobile();
      });
  }
}
